import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/turath2/turath-websites/turath-website-learn/en-dev/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
